export default __webpack_public_path__ + "static/planet2-ded5750a7f3941453d044f0e36299a65.webp";